// Bucketed / enumerated conclusion vocabulary. ENGINE_DESIGN.md §8.1, §7.3; ARCHITECTURE.md §5.
// Every field of a FactsDigest is one of these - that is what makes the digest a cache key.
import { z } from 'zod';
/** <25 weak | 25–40 behind | 40–55 flip | 55–70 ahead | >70 dominant (§8.1). */
export const EquityBucketSchema = z.enum(['weak', 'behind', 'flip', 'ahead', 'dominant']);
/** ≤−15 collapsed | −15..−5 slipped | ±5 held | +5..15 improved | >15 surged (§8.1). */
export const DeltaBucketSchema = z.enum(['collapsed', 'slipped', 'held', 'improved', 'surged']);
/** <1 under1 | 1–3 1to3 | 3–6 3to6 | 6–13 6to13 | >13 over13 (§8.1). */
export const SprBucketSchema = z.enum(['under1', '1to3', '3to6', '6to13', 'over13']);
/** <0.25bb negligible | <1 small | <3 clear | ≥3 severe (§8.1). */
export const EvGapBucketSchema = z.enum(['negligible', 'small', 'clear', 'severe']);
/** Grade bands (§7.3). */
export const GradeBandSchema = z.enum(['excellent', 'good', 'acceptable', 'marginal', 'bad', 'punt']);
/** ICM pressure bucket derived from the risk premium (§6.5). */
export const IcmPressureSchema = z.enum(['none', 'moderate', 'severe']);
/** Effective-stack-depth families (spec §14; ARCHITECTURE.md §6 decisions.stack_depth_bucket). */
export const StackDepthBucketSchema = z.enum(['10bb', '20bb', '40bb', '80bb', '150bb']);
/** Bet-math arithmetic verdict, stored separately from poker grade (§7.3). */
export const ArithmeticVerdictSchema = z.enum(['exact', 'close', 'off']);
/** Whether the chosen sizing intent fit the spot (§7.1). */
export const SizingFitSchema = z.enum(['fits', 'too_small', 'too_big']);
/** Confidence attached to rules and sizing tells (ENGINE_DESIGN.md §6.2). */
export const ConfidenceSchema = z.enum(['high', 'medium', 'low']);
//# sourceMappingURL=buckets.js.map